export default "__VITE_ASSET__C$N2Gw29__"